import { gql, useQuery } from '@apollo/client';

export const GET_ABSENCE_REASONS_BY_COMPANY = gql`
  query($companyId: String!) {
    getAbsenceReasonsByCompany(companyId: $companyId) {
      _id
      name
      color
      absencePaymentStatus
    }
  }
`;

export const useGetAbsenceReasonsByCompany = (companyId?: string) => {
  const { data, loading } = useQuery(GET_ABSENCE_REASONS_BY_COMPANY, {
    variables: { companyId },
    skip: !companyId,
  });
  const absenceReasons = data?.getAbsenceReasonsByCompany || [];

  return { loading, absenceReasons };
};
